<div class="tw-px-6 tw-py-9 tw-font-body tw-relative tw-bg-gray-75 tw-rounded-3 xxs:tw-px-3 xs:tw-px-6">
  <div class="tw-absolute tw-w-6 tw-h-6 tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-[14px] tw-right-[12px] tw-p-1 tw-rounded-full tw-bg-gray-100" (click)="closeBottomSheet()">
    <div class="tw-text-black tw-text-200 tw-font-bold">&#10005;</div>
  </div>
  <div>
    @if (requiredPhotoType === appConfig.Shared.InstantCheckup.Type.FRONT_FACE) {
      <h2 class="tw-text-600 tw-font-bold tw-lowercase first-letter:tw-uppercase" i18n="@@takeFrontPhoto">Take Front photo</h2>
    } @else if (requiredPhotoType === appConfig.Shared.InstantCheckup.Type.SIDE_FACE) {
      <h2 class="tw-text-600 tw-font-bold tw-lowercase first-letter:tw-uppercase" i18n="@@takeSidePhoto">Take Side photo</h2>
    }
    <p class="tw-text-300 tw-font-medium tw-text-gray-500 tw-mt-2" i18n="@@anotherAngle">Another angle will give your doctor better <br /> insight into your skin's condition</p>
    <div class="tw-w-max tw-flex tw-gap-4 tw-mt-10 tw-mx-auto">
      <div>
        <div class="tw-w-[148px] tw-h-52 tw-rounded-4 tw-border-solid tw-border-[4px] tw-border-white tw-shadow-z4">
          <img [src]="data.currentImagePath" class="tw-w-full tw-h-full tw-object-cover tw-rounded-4" />
        </div>
        @if (requiredPhotoType === appConfig.Shared.InstantCheckup.Type.SIDE_FACE) {
          <p class="tw-text-200 tw-font-medium tw-text-gray-500 tw-w-content tw-mx-auto tw-mt-2" i18n="@@frontPhoto"> FRONT PHOTO </p>
        } @else if (requiredPhotoType === appConfig.Shared.InstantCheckup.Type.FRONT_FACE) {
          <p class="tw-text-200 tw-font-medium tw-text-gray-500 tw-w-content tw-mx-auto tw-mt-2" i18n="@@sidePhoto"> SIDE PHOTO </p>
        }
      </div>
      <div>
        <div class="tw-w-[148px] tw-h-52 tw-flex tw-flex-col tw-justify-center tw-items-center tw-rounded-4 tw-border-solid tw-border-[4px] tw-border-white tw-shadow-z8 tw-bg-[#EAEAEA]" (click)="uploadImage()">
          <div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center">
            <img src="https://cdn.cureskin.com/app/img/add_photo.svg" class="tw-w-[30px] tw-h-[30px] tw-object-cover"/>
            <p class="tw-text-200 tw-font-bold tw-text-center tw-text-gray-400 tw-mt-2" i18n="@@takeNowText">Take now</p>
          </div>
        </div>
        @if (requiredPhotoType === appConfig.Shared.InstantCheckup.Type.SIDE_FACE) {
          <p class="tw-text-200 tw-font-medium tw-text-gray-500 tw-w-content tw-mx-auto tw-mt-2" i18n="@@sidePhoto"> SIDE PHOTO </p>
        } @else if (requiredPhotoType === appConfig.Shared.InstantCheckup.Type.FRONT_FACE) {
          <p class="tw-text-200 tw-font-medium tw-text-gray-500 tw-w-content tw-mx-auto tw-mt-2" i18n="@@frontPhoto"> FRONT PHOTO </p>
        }
      </div>
    </div>
    <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4 tw-mt-8">
      @if (requiredPhotoType === appConfig.Shared.InstantCheckup.Type.SIDE_FACE) {
        <p class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300 tw-font-bold tw-relative tw-overflow-hidden tw-text-center tw-capitalize" (click)="uploadImage()" i18n="@@takeSidePhoto">Take Side photo</p>
      } @else if (requiredPhotoType === appConfig.Shared.InstantCheckup.Type.FRONT_FACE) {
        <p class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300 tw-font-bold tw-relative tw-overflow-hidden tw-text-center" (click)="uploadImage()" i18n="@@takeFrontPhoto">Take Front photo</p>
      }
      <p class="tw-text-300 tw-text-teal-600 tw-p-2 tw-font-bold" i18n="@@skip" (click)="closeBottomSheet()">Skip</p>
    </div>
  </div>  
</div>